<template>
  <div>
    <b-container fluid class="mb-4">
      <b-row>
        <b-col class="pl-0">
          <div class="d-flex text-capitalize align-items-center">
            <span>show</span>
            <b-form-select
              :options="entriesOpt(customEntryOptions)"
              class="mx-2"
              :class="isMobile() ? 'wd-100' : 'w-25'"
              v-model="perPageProps"
              v-if="dropdownSizeProps"
              :size="dropdownSizeProps"
            ></b-form-select>
            <b-form-select
              :options="entriesOpt(customEntryOptions)"
              class="mx-2"
              :class="isMobile() ? 'wd-100' : 'w-25'"
              v-model="perPageProps"
              v-else
            ></b-form-select>
            <span>entries</span>
          </div>
        </b-col>
        <b-col class="pr-0">
          <div class="d-flex justify-content-end" :class="{'mt-3': isMobile()}">
            <slot name="right-header"></slot>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <slot></slot>
    <b-row v-if="isMobile()" class="mt-4">
      <b-col cols="12">
        <span class="pl-2"
          >Display {{ fromPageProps }} to {{ toPageProps }} of
          {{ totalEntriesProps }} entries</span
        >
      </b-col>
      <b-col cols="12">
        <b-pagination
          class="mt-4 d-flex justify-content-center flex-grow-1"
          :class="customPagingClass"
          v-model="currentPageProps"
          :total-rows="totalEntriesProps"
          :per-page="perPage"
          :limit="3"
        ></b-pagination>
      </b-col>
    </b-row>
    <div v-else class="d-flex align-items-center justify-content-center">
      <span class="pl-2"
        >Display {{ fromPageProps }} to {{ toPageProps }} of
        {{ totalEntriesProps }} entries</span
      >
      <b-pagination
        class="mt-4 d-flex justify-content-center flex-grow-1"
        :class="customPagingClass"
        v-model="currentPageProps"
        :total-rows="totalEntriesProps"
        :per-page="perPage"
        style="margin-left: -10em"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customRow: {
      type: Object,
    },
    totalEntries: {
      type: Number
    },
    fromPage: {
      type: Number
    },
    toPage: {
      type: Number
    },
    perPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    callbackFunc: {
      type: Function,
      required: true
    },
    customEntryOptions: {
      type: Object,
      default: Object
    },
    customPagingClass: {
      type: Array
    },
    dropdownSizeProps: {
      type: String,
      default: () => null
    }
  },
  async mounted() {
    await ((this.callbackFunc &&
      (this.callbackFunc
        |> (_ => _.call(this))
        |> (_ => _.then(this.processData)))) ||
      null);
  },
  watch: {
    customRow: function (val) {
      this.processData(val)
    }
  },
  methods: {
    valueChanged({ perPage, currentPage }) {
      this.$emit("valueChanged", {
        perPage: perPage,
        currentPage: currentPage
      });
    }
  },
  data: () => ({
    rows: 0,
  }),
  computed: {
    toPageProps: {
      get() {
        return this.toPage;
      },
    },
    fromPageProps: {
      get() {
        return this.fromPage;
      },
    },
    totalEntriesProps: {
      get() {
        return this.totalEntries;
      },
    },
    perPageProps: {
      get() {
        return this.perPage;
      },
      set(val) {
        this.valueChanged({ perPage: val });
      }
    },
    currentPageProps: {
      get() {
        return this.currentPage;
      },
      set(val) {
        this.valueChanged({ currentPage: val });
      }
    }
  }
};
</script>
